<template>
	<div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/discount-coupons" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Gutscheincodes hinzufügen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="discountofferForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
            	<div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Angebotstyp ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="offerType"
	                      v-model="form.offerType"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Angebotstyp"
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Betrag ist erforderlich',
	                    }"
	                  	>
	                    
	                    <v-text-field
	                      v-model="form.offerValue"
	                      :error-messages="errors[0]"
	                      label="Betrag/Prozentsatz"
	                      outlined
	                    ></v-text-field>
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Berechnung ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="calculationType"
	                      v-model="form.calculationType"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Berechnung"
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required|priceInput"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Mindestbetrag ist erforderlich',
	                    }"
	                  	>
	                    <v-text-field
	                      v-model="form.minimumAmount"
	                      :error-messages="errors[0]"
	                      label="Mindestbetrag"
	                      outlined
	                    ></v-text-field>
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Berechnung ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="validFor"
	                      v-model="form.validFor"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Gültigkeit bei Händlern"
	                      outlined
	                      @change="codeValidFor()"
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div" v-show="form.validFor == 'Bei einem spezifischen Händler gültig'">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Berechnung ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="providers"
	                      v-model="form.dealer_ids"
	                      :error-messages="errors[0]"
	                      item-text="brand_name"
	                      item-value="user_id"
	                      label="Gültigkeit bei Händlern"
	                      multiple
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Berechnung ist erforderlich',
	                    }"
	                  	>
	                    <v-select
	                      :items="paymentMethod"
	                      v-model="form.paymentMethod"
	                      :error-messages="errors[0]"
	                      item-text="name"
	                      item-value="id"
	                      label="Bezahlung durch Gustoreich oder Händler"
	                      outlined
	                    />
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
	            	<b-form-group id="fieldset-horizontal">
	                  <ValidationProvider
	                    rules="required"
	                    v-slot="{ errors }"
	                    :custom-messages="{
	                      required: 'Die Gutscheincode ist erforderlich',
	                    }"
	                  	>
	                    <v-text-field
	                      v-model="form.couponCode"
	                      :error-messages="errors[0]"
	                      label="Gutscheincode"
	                      outlined
	                    ></v-text-field>
	                    <span class="form-errors">{{ errors[0] }}</span>
	                  </ValidationProvider>
	                </b-form-group>
	            </div>
	            <div class="col-md-6 form-div">
								<v-menu
									ref="menu"
									v-model="menu"
									:close-on-content-click="false"
									:return-value.sync="date"
									transition="scale-transition"
									offset-y
									max-width="300"
									>
									<template v-slot:activator="{ on, attrs }">
									  <ValidationProvider
									    rules="required"
									    v-slot="{ errors }"
									    :custom-messages="{
									      required: 'Geburtsdatum ist erforderlich.',
									    }"
									  >
									    <v-text-field
									      label="Datum ab"
									      placeholder="TT/MM/JJJJ"
									      :error-messages="errors[0]"
									      outlined
									      v-bind="attrs"
									      v-on="on"
									      v-model="formattedDate"
									    ></v-text-field>
									  </ValidationProvider>
									</template>
									<v-date-picker
									  locale="de-at"
									  :first-day-of-week="1"
									  v-model="date"
									  :min="minDate"
									  no-title
									  scrollable
									  @change="changeDateFormat()"
									>
							  		<v-spacer></v-spacer>
									  <v-btn text color="primary" @click="menu = false">
									    ABBRECHEN
									  </v-btn>
									  <v-btn
									    text
									    color="primary"
									    @click="$refs.menu.save(date)"
									  >
									    OK
									  </v-btn>
									</v-date-picker>
								</v-menu>
	                      
              </div>

              <div class="col-md-6 form-div">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="toDate"
                  transition="scale-transition"
                  offset-y
                  max-width="300"
                	>
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :custom-messages="{
                        required: 'Geburtsdatum ist erforderlich.',
                      }"
                    >
                      <v-text-field
                        label="Datum bis"
                        placeholder="TT/MM/JJJJ"
                        :error-messages="errors[0]"
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        v-model="formattedToDate"
                      ></v-text-field>
                     
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    locale="de-at"
                    :first-day-of-week="1"
                    v-model="toDate"
                    :min="mintoDate"
                    :max="maxDate"
                    no-title
                    scrollable
                    @change="changetoDateFormat()"
                  	>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">
                      ABBRECHEN
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu1.save(toDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="row">
              <div class="fo-row-btn text-right">
                <v-btn
                  class="submit-btn-fill-outline"
                  @click="goToBack"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                  type="submit"
                  :disabled="isDisabled"
                  ref="kt_form_submit_btn"
                  class="submit-btn-fill-color"
                >
                  {{ submitText }}
                </v-btn>
              </div>
            </div>
        </b-form>
    </ValidationObserver>
</div>
</div>
<notifications group="discount-coupons" position="bottom right" />
</div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import adminAPI from "@/api/admin";
import Notifications from "vue-notification";
import axios from "axios";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import HtmlClass from "@/core/services/htmlclass.service";

Vue.use(Notifications);
import { extend } from "vee-validate";

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

	export default{
		name: "EditDiscountCoupons",
		data() {
			return {
				menu: false,
				submitText: "Absenden",
				btnDisable: false,
				date:"",
				toDate:"",
				menu1: false,
				formattedDate: "",
				formattedToDate: "",
				providers: [],
				minDate: new Date(Date.now())
				.toISOString()
				.substr(0, 10),
				mintoDate: new Date(Date.now())
				.toISOString()
				.substr(0, 10),
				maxDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000 * 3600)
	        		.toISOString()
	  				.substr(0, 10),
				offerType: ["Fixer Betrag", "Prozentsatz"],
				calculationType: ["Rabatt vom Bruttowert INKLUSIVE Versandkosten", "Rabatt vom Bruttowert EXKLUSIVE Versandkosten"],
				validFor: ["Bei allen Händlern gültig", "Bei einem spezifischen Händler gültig"],
				paymentMethod: ["Bezahlung durch Gustoreich", "Bezahlung durch Händler"],
				form: {
					id: "",
					offerType: "",
					offerValue: "",
					couponCode: "",
					calculationType: "",
					minimumAmount: "",
					validFor: "",
					paymentMethod: "",
					fromDate: "",
					toDate: "",
					dealer_ids: [],
				},
				status:0,
			}
		},
		created() {
    	if (!this.isAuthenticated) {
	      this.$router.push({ name: "Login" });
	    } else {
	      // show page loading
	      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
	      HtmlClass.init(this.layoutConfig());
	      this.userId = localStorage.getItem("local_products_user_access_id");
	      this.getOfferData();
	    }
	  },
		methods: {
			codeValidFor(){
			 	if(this.form.validFor == 'Bei einem spezifischen Händler gültig'){
					this.getActiveProducers();
				}
				 
			},
			changeDateFormat(){
				this.formattedDate = moment(String(this.date)).format("DD/MM/YYYY");

				var fromDate = this.formattedDate;
				fromDate = fromDate.split("/");
				var minDate = new Date( fromDate[2], fromDate[1] - 1, fromDate[0]);

				this.mintoDate = new Date(minDate.getTime() - new Date().getTimezoneOffset() * 60000)
				        .toISOString()
				        .substr(0, 10)
				this.form.fromDate = this.date;  
						
				const dateFromCheck =new Date(this.date);
				const dateToCheck =new Date(this.form.toDate);

				if (dateFromCheck.getTime() > dateToCheck.getTime()) {
					
					this.toDate = "";
					this.formattedToDate="";
					this.form.toDate = "";
				}
				       
			},
	    changetoDateFormat(){
	      	this.formattedToDate = moment(String(this.toDate)).format("DD/MM/YYYY");
	      	this.form.toDate = this.toDate;
	     
	    },
	    goToBack() {
	      	this.$router.push({ name: "discount-coupons" });
	    },
	    getOfferData() {
	      adminAPI
	        .editDiscountOffer({ id: this.$route.params.id })
	        .then((response) => {
	          if (response.status == "success") {
	            this.form.offerType = response.data.offer_type == "0" ? "Fixer Betrag" :"Prozentsatz";
	            this.form.offerValue = parseFloat(response.data.offer_value).toFixed(2).replace('.',",");
	            this.form.couponCode = response.data.code;
	            this.form.calculationType = response.data.discount_on == "1" ? "Rabatt vom Bruttowert EXKLUSIVE Versandkosten" : "Rabatt vom Bruttowert INKLUSIVE Versandkosten";
	            this.form.minimumAmount = parseFloat(response.data.minimum_order_amount).toFixed(2).replace('.',",");
	            this.form.validFor = response.data.valid_for == "1" ? "Bei allen Händlern gültig" : "Bei einem spezifischen Händler gültig";
	            this.form.paymentMethod = response.data.payment_method == "1" ? "Bezahlung durch Gustoreich" : "Bezahlung durch Händler";
	            if(this.form.validFor == 'Bei einem spezifischen Händler gültig'){
								this.getActiveProducers();

								if (response.data.dealer_code.length) {
		              response.data.dealer_code.forEach((item) => {
		                this.form.dealer_ids.push({
		                  // feature: item.product_feature_detail.feature,
		                  user_id: item.dealer_id,
		                });
		              });
		            }
							}
	            this.formattedDate = moment(String(response.data.valid_from_date)).format("DD/MM/YYYY");
	            this.formattedToDate = moment(String(response.data.valid_to_date)).format("DD/MM/YYYY");
	            this.form.fromDate = response.data.valid_from_date;
	            this.form.toDate = response.data.valid_to_date;
				this.status = response.data.status
	            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
	          } else {
	            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
	            this.$notify({
	              group: "discount-coupons",
	              type: "error",
	              position: "bottom right",
	              text: response.msg,
	              duration: 3000,
	            });
	          }
	        })
	        .catch((err) => {
	          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
	          this.$notify({
	            group: "discount-coupons",
	            type: "error",
	            position: "bottom right",
	            text: err,
	            duration: 3000,
	          });
	        });
	    },
	    getActiveProducers() {
	      axios
	        .get("guest/producer-brandName-list")
	        .then((response) => {
	          var responseJson = response.data;
	          if (responseJson.status == "success") {
	            this.providers = responseJson.data;
	          } else {
	            this.$notify({
	              group: "products",
	              type: "error",
	              position: "bottom right",
	              text: responseJson.msg,
	              duration: 3000,
	            });
	          }
	        })
	        .catch((err) => {
	          this.$notify({
	            group: "products",
	            type: "error",
	            position: "bottom right",
	            text: err,
	            duration: 3000,
	          });
	        });
	    	},
	  	onSubmit() {
      		this.$refs.discountofferForm.validate().then((success) => {
	        if (success) {
	        	
	          this.btnDisable = true;
	          this.submitText = "Wird gespeichert..";
	          let fd = new FormData();
	          fd.append("id", this.$route.params.id);
	          fd.append("offer_type", this.form.offerType == "Prozentsatz" ? '1' : '0');
	          fd.append("offer_value", 
	          	this.form.offerValue.replace(',',"."));
	          fd.append("discount_on", this.form.calculationType == "Rabatt vom Bruttowert EXKLUSIVE Versandkosten" ? '1' : '0');
	          fd.append("minimum_order_amount", this.form.minimumAmount.replace(',',"."));
	          fd.append("code", this.form.couponCode);
	          const dealers = [];
	          if (this.form.validFor != 'Bei allen Händlern gültig') {
	          	for (var i = 0; i < this.form.dealer_ids.length; i++) {
		            dealers.push(this.form.dealer_ids[i]);
		          }
		        	fd.append("dealers", JSON.stringify(dealers));
	          }
        	
	          fd.append("valid_for", this.form.validFor == 'Bei allen Händlern gültig' ? '1' : '0');
	          fd.append("payment_method", this.form.paymentMethod == "Bezahlung durch Gustoreich" ? '1' : '0');
	          fd.append("valid_from_date", this.form.fromDate);
	          fd.append("valid_to_date", this.form.toDate);
	          fd.append("status", this.status);
	          setTimeout(() => {
	            adminAPI
	              .updateDiscountOffer(fd)
	              .then((response) => {
	                if (response.status == "success") {
	                  this.submitText = "Speichern"
	                  this.btnDisable = false;
	                  this.$notify({
	                    group: "discount-coupons",
	                    type: "success",
	                    position: "bottom right",
	                    text: response.msg,
	                    duration: 5000,
	                  });
	                  setTimeout(() => {
	                    this.$router.push({ name: "discount-coupons" });
	                  }, 2000);
	                } else {
	                  this.btnDisable = false;
	                  this.submitText = "Speichern";

	                  this.$notify({
	                    group: "discount-coupons",
	                    type: "error",
	                    position: "bottom right",
	                    text: response.msg,
	                    duration: 5000,
	                  });
	                }
	              })
	              .catch((err) => {
	                this.btnDisable = false;
	                this.submitText = "Speichern";
	                this.$notify({
	                  group: "discount-coupons",
	                  type: "error",
	                  position: "bottom right",
	                  text: err,
	                  duration: 5000,
	                });
	              });
	          }, 2000);
	        } else {
			this.$notify({
				group: "discount-coupons",
				type: "error",
				position: "bottom right",
				text: 'fehlender obligatorischer Wert oder falsches Format',
				duration: 5000,
			});
	          this.formError = true;
	          this.btnDisable = false;
	          this.submitText = "Speichern";
	        }
      		});
    	},
  	},
  	computed: {
	    ...mapGetters([
	      "isAuthenticated",
	      "breadcrumbs",
	      "pageTitle",
	      "layoutConfig",
	      "currentUser",
	    ]),
	    /**
	     * Check if the page loader is enabled
	     * @returns {boolean}
	     */
	    loaderEnabled() {
	      return !/false/.test(this.layoutConfig("loader.type"));
	    },
	    /**
	     * Check if container width is fluid
	     * @returns {boolean}
	     */
	    contentFluid() {
	      return this.layoutConfig("content.width") === "fluid";
	    },
	    /**
	     * Page loader logo image using require() function
	     * @returns {string}
	     */
	    loaderLogo() {
	      return process.env.BASE_URL + this.layoutConfig("loader.logo");
	    },
	    /**
	     * Check if the left aside menu is enabled
	     * @returns {boolean}
	     */
	    asideEnabled() {
	      return !!this.layoutConfig("aside.self.display");
	    },
	    /**
	     * Set the right toolbar display
	     * @returns {boolean}
	     */
	    toolbarDisplay() {
	      // return !!this.layoutConfig("toolbar.display");
	      return true;
	    },
	    /**
	     * Set the subheader display
	     * @returns {boolean}
	     */
	    subheaderDisplay() {
	      return !!this.layoutConfig("subheader.display");
	    },

	    isDisabled: function () {
	      return this.btnDisable;
	    },
  	},
	}
</script>